import React from 'react';
import { HexToRGB } from '@/utils/utils';

const RichTextBlockProd = props => {
  const {
    // visible,
    topMargin,
    horizontalOutterMargin,
    bottomMargin,
    horizontalInnerPadding,
    topPadding,
    bottomPadding,
    hasBg,
    bgColor,
    bgColorOpacity,
    htmlContent,
    cardCorner,
    bgImg,
    bgType,
  } = props || {};
  // 构建背景样式
  const bgStyle = {
    marginTop: `${topMargin / 100}rem`,
    marginBottom: `${bottomMargin / 100}rem`,
    marginLeft: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    marginRight: `${(Number(horizontalOutterMargin || 0) - 12) / 100}rem`,
    backgroundSize: '100%',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      hasBg === 'Y' && bgType === 'Color' ? HexToRGB(bgColor, bgColorOpacity) : 'transparent',
    borderRadius: `${cardCorner}px`,
    backgroundImage:
      hasBg === 'Y' && bgType === 'Image' && bgImg?.src ? `url(${bgImg.src})` : 'none',
  };

  const innerStyle = {
    paddingTop: `${topPadding / 100}rem`,
    paddingBottom: `${bottomPadding / 100}rem`,
    paddingLeft: `${horizontalInnerPadding / 100}rem`,
    paddingRight: `${horizontalInnerPadding / 100}rem`,
  };

  return (
    <div style={bgStyle}>
      <div style={innerStyle}>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    </div>
  );
};

export default RichTextBlockProd;
